import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TableColumn } from "../../../dto/util/table-column";
import { FormField, FormFieldOption } from "../../../dto/util/form-field";
import { ListasService } from "../../../services/listas.service";
import { GestionSolictudesService } from "../../../services/gestion-solicitudes-pj/gestion-solictudes.service";
import { ListaValorDto } from "../../../dto/expediente/lista-valor.dto";
import { Constants_solicitudes } from "../constants/constants-solicitudes";
import { TranslateService } from "@ngx-translate/core";
import { TableAction } from "../../../dto/util/table-action";
import {
  DatosVerificacionDTO,
  DetalleSolicitudPjDTO, DocumentoPjDTO,
  ResponseAprobarDTO, ResponseDescargaDTO,
  ResponseObservatorioDTO,
  ResponseRechazarDTO,
  ResponseVerificacionCorreoDTO,
  ResponseVerificacionDTO,
  SolicitudPjDTO
} from "../models/solicitud-pj-DTO";
import { FormGroup, Validators } from "@angular/forms";
import { Constants } from "../../../constants/constants";
import { AlertaModalService } from "../../../services/util/alerta-modal.service";
import { FiltroDto } from "../../../dto/util/filtro-dto";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ListaValorResponseDto } from '../../../dto/tramites/lista_valor.dto';

@Component({
  selector: 'app-administracion-solicitudes-pj',
  templateUrl: './administracion-solicitudes-pj.component.html',
  styleUrl: './administracion-solicitudes-pj.component.scss'
})
export class AdministracionSolicitudesPJComponent implements OnInit {
  @ViewChild('modalListarDocumentos') modalListarDocumentos!: ElementRef;
  // Listas
  tamanios: ListaValorDto[] = [];
  tamaniosOptions: FormFieldOption[] = [];
  tiposSociedad: ListaValorDto[] = [];
  tiposSociedadOptions: FormFieldOption[] = [];
  motivos: ListaValorDto[] = [];
  motivosOptions: FormFieldOption[] = [];
  columnasSolicitudes: TableColumn[] = [];
  columnasDocumentos: TableColumn[] = [];
  solicitudes: DetalleSolicitudPjDTO[] = [];
  documentos: DocumentoPjDTO[] = [];
  idsArchivos: number[] = [];
  // Tables
  tamanoPagina = 10;
  totalPaginas = 0;
  paginaActual = 1;
  accionesSolicitudes: TableAction[] = [];
  // Formularios
  camposVerificacion: FormField[] = [];
  formVerificacion!: FormGroup;
  camposObservatorio: FormField[] = [];
  formObservatorio!: FormGroup;
  campoAprobacion: FormField[] = [];
  formAprobacion!: FormGroup;
  camposRechazo: FormField[] = [];
  formRechazo!: FormGroup;
  // Multilenguaje
  gestionText: any = {};
  comunText: any = {};
  // Boolean
  verificarSolicitud = false;
  registrarObservatorio = false;
  verificarCorreo = false;
  rechazarSolicitud = false;
  mostrarSolicitudes = true;
  // Number
  idSolicitud = 0;
  // Filtros
  filtroSolicitud: any = {
    filtros: {
      nit: '',
      idEstado: 0,
    },
    ordenarAsc: false,
    ordenarPor: '',
    selectedPage: 0,
    tamanoPagina: 0
  }
  // String
  nit!: string;
  safeUrl!: SafeUrl;

  tiposEstado: (ListaValorDto | undefined)[] = [];

  constructor(
    private listaService: ListasService,
    private gestionService: GestionSolictudesService,
    private translateService: TranslateService,
    private alertService: AlertaModalService,
    private sanitizer: DomSanitizer
  ) {
  }
  ngOnInit(): void {
    // Lista tamaños empresa
    this.listarTamanios();
    // Lista tipos sociedad
    this.listarSociedades();
    // Lista motivos
    this.listarMotivos();
    // Lista solicitudes
    this.listarSolicitudes();
    this.getListaCius();
    // Columnas
    this.initColumns();
    this.initColumnsDocuments();

    this.listaEstados();
    // Multilenguaje
    this.translateService.stream('gestion solicitudes-pj').forEach(text => {
      for (const key of Object.keys(text)) {
        this.gestionText[key] = text[key];
        this.initColumns();
        this.initColumnsDocuments();
        // Formularios
        this.initFormVerificarSolicitud();
        this.initFormRegistrarObservatorio();
        this.initFormVerificarCorreo();
        this.initFormRechazarSolicitud();
      }
    });
    this.translateService.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
        this.initColumns();
        // Formularios
        this.initFormVerificarSolicitud();
        this.initFormRegistrarObservatorio();
        this.initFormVerificarCorreo();
        this.initFormRechazarSolicitud();
      }
    });
  }
  // Función que consume el servicio de listas para obtener los tamaños de empresa
  listarTamanios() {
    this.listaService.listaValor(Constants_solicitudes.LISTA_TAMANIOS).subscribe(tamanios => {
      this.tamanios = tamanios;
      this.tamaniosOptions = tamanios.map(item => ({
        Id: item.Id ?? '',
        Nombre: item.Valor || '',
      }));
      this.initFormRegistrarObservatorio();
    });
  }
  // Función que consume el servicio de listas para obtener los tipos de sociedad
  listarSociedades() {
    this.listaService.listaValor(Constants_solicitudes.LISTA_TIPOS_SOCIEDAD).subscribe(tipos => {
      this.tiposSociedad = tipos;
      this.tiposSociedadOptions = tipos.map(item => ({
        Id: item.Id ?? '',
        Nombre: item.Valor || '',
      }));
      this.initFormRegistrarObservatorio();
    });
  }
  // Función que consume el servicio de listas para obtener los motivos de rechazo
  listarMotivos() {
    this.listaService.listaValor(Constants_solicitudes.LISTA_MOTIVOS).subscribe(motivos => {
      this.motivos = motivos;
      this.motivosOptions = motivos.map(item => ({
        Id: item.Id ?? '',
        Nombre: item.Valor || '',
      }));
      this.initFormRechazarSolicitud();
    });
  }

  listaEstados() {
    this.listaService.listaValor(Constants.ESTADO_SOLICITUD_EMPRESA).subscribe(estados => {
      this.tiposEstado = estados;
      this.initColumns();
    });

  }
  // Se inicializan las columnas de la tabla
  initColumns() {
    this.columnasSolicitudes = [
      {
        id: 'marcaTiempo',
        field: 'marcaTiempo',
        title: this.gestionText['marca'],
        type: 'text',
        filterable: false,
        sortable: true,
      },
      {
        id: 'nit',
        field: 'nit',
        title: this.gestionText['nit'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'razonSocial',
        field: 'razonSocial',
        title: this.gestionText['razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'correoNotificacion',
        field: 'correoNotificacion',
        title: this.gestionText['correo'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'anexos',
        field: 'anexos',
        title: this.gestionText['documentos'],
        type: 'text',
        filterable: false,
        sortable: false,
        accion: item => {
          this.openModalDocumentos(item);
        },
      },
      {
        id: 'estado',
        field: 'estado',
        title: this.gestionText['estado'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'idEstado',
        elements: this.tiposEstado,
        option: 'Valor',
        value: 'Id',
      },
    ]
    // Acciones
    this.accionesSolicitudes = [
      {
        type: 'button',
        title: this.gestionText['tooltip-verificar'],
        icon: 'search',
        idAccion: '1',
      },
      {
        type: 'button',
        visible(item) {
          return item.verificada;
        },
        title: this.gestionText['tooltip-aprobar'],
        icon: 'check',
        idAccion: '2',
      },
      {
        type: 'button',
        title: this.gestionText['tooltip-rechazar'],
        icon: 'close',
        idAccion: '3',
      },
    ];
  }
  // Se inicializan las columnas de la tabla que lista los archivos de la solicitud
  initColumnsDocuments() {
    this.columnasDocumentos = [
      {
        id: 'nombreArchivo',
        field: 'nombreArchivo',
        title: this.gestionText['nombre-archivo'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'extension',
        field: 'extension',
        title: this.gestionText['extension-archivo'],
        type: 'text',
        filterable: false,
        sortable: false,
      }
    ]
  }

  getListaCius() {
    this.listaService
      .listaValor(Constants.CODIGO_CIIU)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.camposObservatorio = this.camposObservatorio.map(field => {
          if (field.name === 'actividadEconomicaPrincipal') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Otro_valor!,
              Nombre: `${item.Otro_valor!} - ${item.Valor!}`,
            }));
          }
          return field;
        });
      });
  }
  // Función que consume el servicio de listar solicitudes
  listarSolicitudes(nit?: string, orden?: string, page?: number, pageSize?: number, idEstado?: number) {
    this.gestionService.solicitudes(
      nit ? nit : undefined,
      orden ? orden : undefined,
      page ? page : undefined,
      pageSize ? pageSize : undefined,
      idEstado ? idEstado : undefined
    ).subscribe((resp: SolicitudPjDTO) => {
      this.solicitudes = resp.data;
      this.paginaActual = resp.meta.page;
      this.totalPaginas = resp.meta.totalPages;
      this.tamanoPagina = resp.meta.pageSize;
      this.solicitudes = this.solicitudes.map(solicitudes => ({
        ...solicitudes,
        marcaTiempo: new Date(solicitudes.marcaTiempo).toLocaleString('es-CO', {
          timeZone: 'UTC',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }),
        anexos: solicitudes.documentos.length > Constants_solicitudes.CERO
          ? this.gestionText['adjuntos']
          : undefined,
      }));
    });
  }
  // Se inicializa formulario de verificación de la solicitud
  initFormVerificarSolicitud() {
    this.camposVerificacion = [
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['datos'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['solicitud'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['verificacion'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['nit'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'nit',
        label: '',
        type: 'text',
        disabled: true,
      },
      {
        name: 'nitVerificar',
        label: '',
        type: 'text',
        validation: [
          Validators.required,
          Validators.maxLength(Constants_solicitudes.MAX_NUEVE),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['nit-required'],
          maxlength: this.comunText['nit-max'],
          pattern: this.comunText['nit-error'],
          noCoincide: this.gestionText['no-coincide']
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['razon-social'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'razonSocial',
        label: '',
        type: 'text',
        disabled: true,
      },
      {
        name: 'razonSocialVerificar',
        label: '',
        type: 'text',
        validation: [
          Validators.required,
          Validators.minLength(Constants_solicitudes.MIN_TRES),
          Validators.maxLength(Constants_solicitudes.MAX_CINCUENTA),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength-50'],
          pattern: this.comunText['razon-social-pattern'],
          noCoincide: this.gestionText['no-coincide']
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['doc-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'documentoRepresentanteLegal',
        label: '',
        type: 'text',
        disabled: true,
      },
      {
        name: 'documentoRepresentanteLegalVerificar',
        label: '',
        type: 'text',
        validation: [
          Validators.required,
          Validators.minLength(Constants_solicitudes.MIN_CUATRO),
          Validators.maxLength(Constants_solicitudes.MAX_DOCE),
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.comunText['numero-documento-maxlength'],
          minlength: this.comunText['numero-documento-minlength'],
          pattern: this.comunText['numero-documento-pattern'],
          noCoincide: this.gestionText['no-coincide']
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.gestionText['correo-notificacion'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'correoNotificacion',
        label: '',
        type: 'text',
        disabled: true,
      },
      {
        name: 'correoNotificacionVerificar',
        label: '',
        type: 'text',
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(Constants_solicitudes.MAX_CIEN),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['correo-maxlength'],
          noCoincide: this.gestionText['no-coincide']
        },
      },
    ]
  }
  // Se inicializa formulario para el registro de datos observatorio de Justicia
  initFormRegistrarObservatorio() {
    this.camposObservatorio = [
      {
        name: 'idTamanoEmpresa',
        label: this.gestionText['tamanio-empresa'],
        type: 'select',
        options: this.tamaniosOptions,
        width: '6',
        validation: [
          Validators.required
        ],
        required:true,
        errorMessages: {
          required: this.gestionText['tamanio-required'],
        },
      },
      {
        name: 'actividadEconomicaPrincipal',
        label: this.gestionText['actividad'],
        type: 'select',
        width: '6',
        required:true,
        validation: [
          Validators.required,
        ],
        errorMessages: {
          required: this.gestionText['actividad-required'],
          pattern: this.comunText['solo-numeros']
        },
      },
      {
        name: 'numeroEmpleados',
        label: this.gestionText['empleados'],
        type: 'text',
        width: '6',
        required:true,
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.gestionText['empleados-required'],
          pattern: this.comunText['solo-numeros']
        },
      },
      {
        name: 'fechaConstitucion',
        label: this.gestionText['fecha'],
        type: 'date',
        width: '6',
        required: true,
        validation: [
          Validators.required
        ],
        isMaxDate: true,
        errorMessages: {
          required: this.gestionText['fecha-required'],
          fechaInvalida: this.comunText['fecha-invalida']
        },
      },
      {
        name: 'idTipoSociedad',
        label: this.gestionText['tipo'],
        type: 'select',
        required:true,
        options: this.tiposSociedadOptions,
        width: '6',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.gestionText['tipo-required'],
        },
      },
    ]
  }
  // Se inicializa formulario de verificación del correo
  initFormVerificarCorreo() {
    this.campoAprobacion = [
      {
        name: 'correoVerificacion',
        label: this.gestionText['verificacion-correo'],
        type: 'text',
        required:true,
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(Constants_solicitudes.MAX_CIEN),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['correo-maxlength'],
        },
      },
    ]
  }
  // Se inicializa formulario para rechazar la solicitud
  initFormRechazarSolicitud() {
    this.camposRechazo = [
      {
        name: 'correoNotificacion',
        label: this.gestionText['correo'],
        type: 'text',
        required:true,
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(Constants_solicitudes.MAX_CIEN),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['correo-maxlength'],
        },
      },
      {
        name: 'idMotivoRechazo',
        label: this.gestionText['motivo'],
        type: 'select',
        required:true,
        options: this.motivosOptions,
        width: '12',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.gestionText['tamanio-required'],
        },
      },
      {
        name: 'descripcionMotivo',
        label: this.gestionText['descripcion'],
        type: 'textarea',
        width: '12',
        dependsOn: 'idMotivoRechazo',
        visibilityCondition: value => {
          // Busca "OTRO MOTIVO" en la lista
          const motivo = this.motivosOptions.find(
            item => item.Nombre === Constants_solicitudes.OTRO_MOTIVO
          )?.Id;
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor corresponde a "OTRO MOTIVO"
          return motivo ? value == motivo : true;
        },
        required:true,
        errorMessages: {
          required: this.gestionText['descripcion-required'],
          maxlength: this.gestionText['descripcion-maxlength'],
          pattern: this.comunText['razon-social-pattern']
        },
      },
    ]
  }

  // Función que gestiona las acciones de la tabla
  acciones(event: any) {
    this.idSolicitud = event.item.id;
    // Acción verificar
    if (event.idAccion === Constants_solicitudes.ACCION_VERIFICAR) {
      this.verificarSolicitud = true;
      this.registrarObservatorio = false;
      this.verificarCorreo = false;
      this.rechazarSolicitud = false;
      this.mostrarSolicitudes = false;
      this.obtenerDatosVerificacion();
      // Acción aprobar
    } else if (event.idAccion === Constants_solicitudes.ACCION_APROBAR) {
      this.verificarSolicitud = false;
      this.registrarObservatorio = true;
      this.verificarCorreo = false;
      this.rechazarSolicitud = false;
      this.mostrarSolicitudes = false;
      // Acción rechazar
    } else if (event.idAccion === Constants_solicitudes.ACCION_RECHAZAR) {
      this.verificarSolicitud = false;
      this.registrarObservatorio = false;
      this.verificarCorreo = false;
      this.rechazarSolicitud = true;
      this.mostrarSolicitudes = false;
    }
  }
  // Función que consume el servicio que obtiene el detalle de la soliciutd
  obtenerDatosVerificacion() {
    this.gestionService.datosVerificacion(this.idSolicitud).subscribe((resp: DatosVerificacionDTO) => {
      if (resp) {
        this.camposVerificacion = this.camposVerificacion.map(
          field => {
            if (field.name === 'nit') {
              field.value = resp.datos.nit;
            }
            if (field.name === 'razonSocial') {
              field.value = resp.datos.razonSocial;
            }
            if (field.name === 'documentoRepresentanteLegal') {
              field.value = resp.datos.documentoRepresentanteLegal;
            }
            if (field.name === 'correoNotificacion') {
              field.value = resp.datos.correoNotificacion;
            }
            return field;
          }
        );
      }
    });
  }
  // Se consume el servicio de verificar información
  capturarVerificarForm(form: FormGroup) {
    this.formVerificacion = form;
    this.gestionService.verificar(
      this.idSolicitud,
      {
        nit: this.formVerificacion?.get('nitVerificar')?.value,
        razonSocial: this.formVerificacion?.get('razonSocialVerificar')?.value,
        documentoRepresentanteLegal: this.formVerificacion?.get('documentoRepresentanteLegalVerificar')?.value,
        correoNotificacion: this.formVerificacion?.get('correoNotificacionVerificar')?.value,
      }).subscribe((resp: ResponseVerificacionDTO) => {
        if (resp.verificacionExitosa) {
          this.listarSolicitudes();
          this.alertService.exito(resp.mensaje).then(() => {
            this.volver(false);
          });
        } else {
          this.alertService.error(resp.mensaje);
          resp.campos.forEach(campo => {
            if (campo.campo === 'nit') {
              if (!campo.coincide) {
                this.formVerificacion?.get('nitVerificar')?.setErrors({
                  'noCoincide': true,
                });
              } else {
                this.formVerificacion?.get('nitVerificar')?.setErrors(null);
              }
            }
            if (campo.campo === 'razonSocial') {
              if (!campo.coincide) {
                this.formVerificacion?.get('razonSocialVerificar')?.setErrors({
                  'noCoincide': true,
                });
              } else {
                this.formVerificacion?.get('razonSocialVerificar')?.setErrors(null);
              }
            }
            if (campo.campo === 'documentoRepresentanteLegal') {
              if (!campo.coincide) {
                this.formVerificacion?.get('documentoRepresentanteLegalVerificar')?.setErrors({
                  'noCoincide': true,
                });
              } else {
                this.formVerificacion?.get('documentoRepresentanteLegalVerificar')?.setErrors(null);
              }
            }
            if (campo.campo === 'correoNotificacion') {
              if (!campo.coincide) {
                this.formVerificacion?.get('correoNotificacionVerificar')?.setErrors({
                  'noCoincide': true,
                });
              } else {
                this.formVerificacion?.get('correoNotificacionVerificar')?.setErrors(null);
              }
            }
          });
        }
      });
  }
  // Se consume el servicio de guardar datos observatorio de Justicia
  capturarObservatorioForm(form: FormGroup) {
    this.formObservatorio = form;
    this.gestionService.guardarObservatorio(
      this.idSolicitud,
      {
        idTamanoEmpresa: this.formObservatorio?.get('idTamanoEmpresa')?.value,
        actividadEconomicaPrincipal: this.formObservatorio?.get('actividadEconomicaPrincipal')?.value,
        numeroEmpleados: Number(this.formObservatorio?.get('numeroEmpleados')?.value),
        idTipoSociedad: this.formObservatorio?.get('idTipoSociedad')?.value,
        fechaConstitucion: this.formObservatorio?.get('fechaConstitucion')?.value
      }
    ).subscribe({
      next: (resp: ResponseObservatorioDTO) => {
        if (resp) {
          this.alertService.exito(resp.mensaje);
          // Se muestra la pantalla con el campo de verificar correo
          this.verificarSolicitud = false;
          this.registrarObservatorio = false;
          this.verificarCorreo = true;
          this.rechazarSolicitud = false;
          this.mostrarSolicitudes = false;
        }
      }, error: (err) => {
        if (err.error.statusCode === Constants_solicitudes.STATUS_BAD_REQUEST) {
          this.alertService.error(err.error.message);
        }
      }
    });
  }
  // Se consume el servicio de verificar correo
  capturarVerificarCorreoForm(form: FormGroup) {
    this.formAprobacion = form;
    this.gestionService.verificarCorreo(
      this.idSolicitud,
      {
        correoVerificacion: this.formAprobacion?.get('correoVerificacion')?.value
      }
    ).subscribe((resp: ResponseVerificacionCorreoDTO) => {
      if (!resp.coincide) {
        this.alertService.error(resp.mensaje);
      } else {
        // Debido a que ya se guardaron los datos observatorio y la verificación del correo es exitosa,
        // se consume el servicio de aprobar la solicitud
        this.aprobarSolicitud(resp.correoVerificado);
      }
    });
  }
  // Se consume el servicio de rechazar solicitud
  capturarRechazarForm(form: FormGroup) {
    this.formRechazo = form;
    this.gestionService.rehazar(this.idSolicitud, {
      correoNotificacion: this.formRechazo?.get('correoNotificacion')?.value,
      idMotivoRechazo: this.formRechazo?.get('idMotivoRechazo')?.value,
      descripcionMotivo: this.formRechazo?.get('descripcionMotivo')?.value
    }).subscribe({
      next: (resp: ResponseRechazarDTO) => {
        if (resp.exitosa) {
          this.alertService.exito(resp.mensaje).then(() => {
            this.volver(false);
          });
        } else {
          this.alertService.error(resp.mensaje);
        }
      },
      error: (err) => {
        if (err.error.statusCode === Constants_solicitudes.STATUS_BAD_REQUEST) {
          this.alertService.error(err.error.message);
        }
      }
    });
  }
  agregarValidaciones(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName === 'idMotivoRechazo') {
      const idMotivo = this.motivosOptions.find(
        motivo => motivo.Nombre === Constants_solicitudes.OTRO_MOTIVO)?.Id;
      const value = event?.controlValue as FormFieldOption;
      if (value?.Id === idMotivo) {
        event.form?.get('descripcionMotivo')?.addValidators([
          Validators.required,
          Validators.maxLength(Constants_solicitudes.MAX_CINCUENTA),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ]);
        event.form?.get('descripcionMotivo')?.updateValueAndValidity();
      } else {
        event.form?.get('descripcionMotivo')?.clearValidators();
        event.form?.get('descripcionMotivo')?.updateValueAndValidity();
      }
    }
  }
  // Función que consume el servicio de probar la solicitud
  aprobarSolicitud(correo: string) {
    this.gestionService.aprobar(
      this.idSolicitud,
      {
        correoVerificacion: correo
      }
    ).subscribe((resp: ResponseAprobarDTO) => {
      if (resp.exitosa) {
        this.alertService.exito(resp.mensaje).then(() => {
          this.volver(false);
        });
      } else {
        this.alertService.error(resp.mensaje);
      }
    });
  }
  // Función que maneja el filtro de la columna NIT
  filtrar(evento: FiltroDto<object>) {
    this.filtroSolicitud = evento;
    this.listarSolicitudes(
      this.filtroSolicitud.filtros.nit,
      this.filtroSolicitud.ordenarAsc
        ? Constants_solicitudes.ASC
        : Constants_solicitudes.DESC,
      this.filtroSolicitud.selectedPage,
      this.filtroSolicitud.tamanoPagina,
      this.filtroSolicitud.filtros?.idEstado
    );
  }
  // Función que abre el modal que lista los documentos de la solicitud
  openModalDocumentos(item: DetalleSolicitudPjDTO) {
    this.documentos = item.documentos;
    this.modalListarDocumentos.nativeElement.click();
  }
  // Se muestra la pantalla con el listado de solicitudes
  volver(showAlert: boolean) {
    if (showAlert) {
      if (this.verificarSolicitud) {
        this.alertService.confirmacion(
          this.gestionText['esta_seguro_verificacion_titulo'],
          this.gestionText['esta_seguro_verificacion_contenido'],
          () => {
            this.verificarSolicitud = false;
            this.registrarObservatorio = false;
            this.verificarCorreo = false;
            this.rechazarSolicitud = false;
            this.mostrarSolicitudes = true;
          },
          () => {

          }
        );
      }
      if (this.registrarObservatorio || this.verificarCorreo) {
        this.alertService.confirmacion(
          this.gestionText['esta_seguro_aprobacion_titulo'],
          this.gestionText['esta_seguro_aprobacion_contenido'],
          () => {
            this.verificarSolicitud = false;
            this.registrarObservatorio = false;
            this.verificarCorreo = false;
            this.rechazarSolicitud = false;
            this.mostrarSolicitudes = true;
          },
          () => {

          }
        );
      }
      if (this.rechazarSolicitud) {
        this.alertService.confirmacion(
          this.gestionText['esta_seguro_rechazo_contenido'],
          this.gestionText['esta_seguro_rechazo_titulo'],
          () => {
            this.verificarSolicitud = false;
            this.registrarObservatorio = false;
            this.verificarCorreo = false;
            this.rechazarSolicitud = false;
            this.mostrarSolicitudes = true;
          },
          () => {

          }
        );
      }
    } else {
      this.verificarSolicitud = false;
      this.registrarObservatorio = false;
      this.verificarCorreo = false;
      this.rechazarSolicitud = false;
      this.mostrarSolicitudes = true;
    }

  }
  // Función que captura los archivos seleccionados
  capturarArchivos(archivos: DocumentoPjDTO[]) {
    this.idsArchivos = archivos.map(archivo => archivo.id);
  }
  // Función que consume el servicio de descargar archivos
  descargarArchivos() {
    this.gestionService.descargar({
      idsAnexos: this.idsArchivos
    }).subscribe((resp: ResponseDescargaDTO) => {
      if (resp.documentos) {
        resp.documentos.forEach((doc, index) => {
          if (doc.exitoso && doc.url) {
            setTimeout(() => {
              const enlace = document.createElement('a');
              enlace.href = doc.url;
              enlace.download = doc.nombreArchivo;
              enlace.target = '_blank';
              enlace.rel = 'noopener noreferrer';

              document.body.appendChild(enlace);
              enlace.click();

              setTimeout(() => {
                document.body.removeChild(enlace);
              }, 100);
            }, index * 500);
          }
        });
      }
    });
  }

  validarFecha(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName === 'fechaConstitucion') {
      const fecha = event?.form?.controls['fechaConstitucion']?.value;
      const fechaFormateada = new Date(fecha);
      // Se valida que la fecha de constitución no sea mayor a la fecha actual
      if (fechaFormateada > new Date()) {
        event?.form?.controls['fechaConstitucion']?.setErrors({
          'fechaInvalida': true
        });
      } else {
        // Se valida que la fecha sea difrente de ''
        if (fecha === '') {
          event?.form?.controls['fechaConstitucion']?.setErrors({
            'required': true
          });
        } else {
          event?.form?.controls['fechaConstitucion']?.setErrors(null);
        }
      }
    }
  }
  public readonly Constants_solicitudes = Constants_solicitudes;
}
